<ng-container *ngIf="scorecard$ | async as activeScorecards">
  <div class="container badge-carousel-div" *ngIf="activeScorecards.length > 0">
    <div class="d-flex justify-content-between scorecard-carousel-links">
      <h5 class="badge-carousel-subheading fgbcl-subheading-title">
        {{ title ? title : ('badge.featured.challenges' | translate) }}
      </h5>
      <div class="d-flex align-items-center cursor-pointer mb-10" *ngIf="showAllView" [routerLink]="[link]">
        <span class="scorecard-featured-link">{{ 'badge.featured.challenges.show.all.link' | translate }}</span>
        <span class="icon material-icons ps-2 scorecard-featured-link-icon" aria-hidden="true">arrow_forward_ios</span>
      </div>
    </div>
    <div *ngIf="badgeDescription" class="badge-description">{{ badgeDescription }}</div>
    <div class="d-none d-lg-block">
      <owl-carousel-o [options]="customOptions" (dragging)="isDragging = $event.dragging">
        <ng-container *ngFor="let scorecard of activeScorecards">
          <ng-container *ngIf="!scorecard.Hidden">
            <ng-template [width]="305" carouselSlide>
              <div class="overlay">
                <ng-container
                  [ngTemplateOutlet]="scorecardView"
                  [ngTemplateOutletContext]="{ scorecard: scorecard, disabled: isDragging }"
                ></ng-container>
              </div>
            </ng-template>
          </ng-container>
        </ng-container>
      </owl-carousel-o>
    </div>
    <div class="d-block d-lg-none">
      <owl-carousel-o [options]="customOptions">
        <ng-container *ngFor="let scorecard of activeScorecards">
          <ng-container *ngIf="!scorecard.Hidden">
            <ng-template carouselSlide>
              <div>
                <ng-container
                  [ngTemplateOutlet]="scorecardView"
                  [ngTemplateOutletContext]="{ scorecard: scorecard, disabled: false }"
                ></ng-container>
              </div>
            </ng-template>
          </ng-container>
        </ng-container>
      </owl-carousel-o>
    </div>
  </div>

  <ng-container *ngIf="showPlaceholder">
    <div class="container challenges-placeholder" *ngIf="activeScorecards.length == 0">
      <!--Scorecard Placeholder-->
      <div class="no-items m-0 no-results-placeholder-div">
        <div
          class="svg svg-info vs-svg ms-auto me-auto"
          fgbAnimateSvg
          [inlineSVG]="'assets/images/placeholders/Challenges.svg'"
        ></div>
        <div class="no-results-placeholder">{{ 'scorecards.placeholder.description' | translate }}</div>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-template #scorecardView let-scorecard="scorecard" let-disabled="disabled">
  <ng-container [ngSwitch]="scorecard.ScoreCardDisplayType">
    <ng-container *ngSwitchCase="scorecardDisplayType.punchcardView">
      <fgbcl-scorecard-punchcard-view
        [icon]="icon"
        [scorecard]="scorecard"
        [confettiColors]="confettiColors"
        [disabled]="disabled"
        [isSponsorInBody]="isSponsorInBody"
      ></fgbcl-scorecard-punchcard-view>
    </ng-container>
    <ng-container *ngSwitchCase="scorecardDisplayType.soloAction">
      <fgbcl-scorecard-punchcard-view
        [icon]="icon"
        [scorecard]="scorecard"
        [confettiColors]="confettiColors"
        [disabled]="disabled"
        [isSponsorInBody]="isSponsorInBody"
      ></fgbcl-scorecard-punchcard-view>
    </ng-container>
    <ng-container *ngSwitchCase="scorecardDisplayType.singleAction">
      <fgbcl-scorecard-punchcard-view
        [icon]="icon"
        [scorecard]="scorecard"
        [confettiColors]="confettiColors"
        [disabled]="disabled"
        [isSponsorInBody]="isSponsorInBody"
      ></fgbcl-scorecard-punchcard-view>
    </ng-container>
    <ng-container *ngSwitchCase="scorecardDisplayType.milestoneProgressBarView">
      <fgbcl-milestones-progress-view
        [icon]="icon"
        [originScorecard]="scorecard"
        [confettiColors]="confettiColors"
        [disabled]="disabled"
        [isSponsorInBody]="isSponsorInBody"
      ></fgbcl-milestones-progress-view>
    </ng-container>
    <ng-container *ngSwitchCase="scorecardDisplayType.numberView">
      <fgbcl-scorecard-number-view
        [icon]="icon"
        [scorecard]="scorecard"
        [confettiColors]="confettiColors"
        [disabled]="disabled"
        [isSponsorInBody]="isSponsorInBody"
      ></fgbcl-scorecard-number-view>
    </ng-container>
    <ng-container *ngSwitchCase="scorecardDisplayType.streakView">
      <fgbcl-scorecard-streak [scorecard]="scorecard" [isSponsorInBody]="isSponsorInBody"></fgbcl-scorecard-streak>
    </ng-container>
  </ng-container>
</ng-template>
